import React from "react";
import {
  ActivityIcon,
  ActivityReportIcon,
  AddCallIcon,
  AddFolderIcon,
  AddIcon,
  AddItemIcon,
  AddNewIcon,
  AIFilledIcon,
  AiMailIcon,
  AIOutlinedIcon,
  AlignBottomIcon,
  AlignHorizontallyIcon,
  AlignLeftIcon,
  AlignRightIcon,
  AlignTopIcon,
  AlignVerticallyIcon,
  AnniversaryIcon,
  ApiCodeIcon,
  ArchiveIcon,
  ArrowDownCircleIcon,
  ArrowDownIcon,
  ArrowLeftCircleIcon,
  ArrowLeftIcon,
  ArrowRightCircleIcon,
  ArrowRightIcon,
  ArrowUpCircleIcon,
  ArrowUpIcon,
  AttachCircleIcon,
  AttachmentIcon,
  AttachSquareIcon,
  AudienceIcon,
  AudioSquareIcon,
  AutomationIcon,
  Backward10SecIcon,
  Backward15SecIcon,
  Backward5SecIcon,
  BackwardIcon,
  BackwardItemIcon,
  BarChartOutlinedIcon,
  BelowIcon,
  BezierIcon,
  BirthdayIcon,
  BlankFolderIcon,
  Blend2Icon,
  BlendIcon,
  BlurIcon,
  BoldIcon,
  BookmarkIcon,
  BounceIcon,
  Box,
  BrushBorderedIcon,
  BrushIcon,
  BrushOutlinedIcon,
  BucketCircleIcon,
  BulbIcon,
  CalenderIcon,
  CallIcon,
  CallMissedIcon,
  CallOutgoingIcon,
  CameraIcon,
  CameraOffIcon,
  CampaignIcon,
  Candle2Icon,
  CandleIcon,
  CardsIcon,
  Category2Icon,
  Chart1Icon,
  Chart2Icon,
  ChartFailIcon,
  ChartOutlinedIcon,
  ChartSuccessIcon,
  CheckboxUncheckedIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpDownIcon,
  ChevronUpIcon,
  ChurnReportsIcon,
  ClockIcon,
  CloseBorderedIcon,
  CloseCircleIcon,
  CloseIcon,
  CodeIcon,
  CollabIcon,
  CollapseSidebarIcon,
  ColorFilterIcon,
  ColorGroupIcon,
  ColorPaletteIcon,
  ColorsSquareIcon,
  ColorSwatchIcon,
  ColumnsIcon,
  CompanyIcon,
  ComponentIcon,
  ConvertShape2Icon,
  ConvertShapeIcon,
  CopySuccessIcon,
  CreateIcon,
  CropIcon,
  DashboardIcon,
  DealsIcon,
  DecreaseIcon,
  DeleteIcon,
  DesignToolsIcon,
  DevicesControllerIcon,
  DiagramIcon,
  DividerIcon,
  DollarIcon,
  DownloadIcon,
  DragIndicatorIcon,
  DropIcon,
  DuplicateIcon,
  Edit1Icon,
  EditIcon,
  Element1Icon,
  Element2Icon,
  Element3Icon,
  Element4Icon,
  ElementEqualIcon,
  ElementPlusIcon,
  Email2Icon,
  EmailBuilderIcon,
  EmailIcon,
  EraserIcon,
  EraserSquareIcon,
  ExpandIcon,
  ExpandSidebarIcon,
  ExportCircleIcon,
  ExportIcon,
  ExtendIcon,
  FatRowsIcon,
  FavChartIcon,
  FilterIcon,
  FirstLineIcon,
  FlashCircleIcon,
  FlashIcon,
  Folder2Icon,
  FolderIcon,
  FormatCircleIcon,
  FormatSquareIcon,
  FormBuilderIcon,
  FormEntriesIcon,
  Forward10SecIcon,
  Forward15SecIcon,
  Forward5SecIcon,
  ForwardIcon,
  ForwardItemIcon,
  FullScreenIcon,
  GlassBikarIcon,
  Grid1Icon,
  Grid2Icon,
  Grid3Icon,
  Grid4Icon,
  Grid5Icon,
  Grid6Icon,
  Grid7Icon,
  Grid8Icon,
  Grid9Icon,
  GridEditIcon,
  GridEraserIcon,
  GridIcon,
  GridLockIcon,
  GridOutlinedIcon,
  HealthIcon,
  HeartOutlinedIcon,
  HelpIcon,
  HomeHashTagIcon,
  HomeTrendDownIcon,
  HomeTrendUpIcon,
  ImageAddIcon,
  ImageEditIcon,
  ImageExportIcon,
  ImageFavIcon,
  ImageIcon,
  ImageImportIcon,
  ImageNoBorderIcon,
  ImageOffIcon,
  ImageRemoveIcon,
  ImageTickIcon,
  InboxIcon,
  IncomingCallIcon,
  IncreaseIcon,
  InfoCircleIcon,
  KanbanIcon,
  LaughEmojiIcon,
  LaughFillEmojiIcon,
  LayerOutlinedIcon,
  LayoutIcon,
  LifebouyIcon,
  Link2Icon,
  Link4Icon,
  LinkCircleIcon,
  LinkIcon,
  LinkNewIcon,
  LinkSquareIcon,
  ListIcon,
  LoaderIcon,
  LocationIcon,
  LockIcon,
  LoginIcon,
  LogoIcon,
  LogoutIcon,
  MagicPenIcon,
  MailIcon,
  MailSettingsIcon,
  MainComponentIcon,
  ManageIcon,
  MapOutlinedIcon,
  MarketingIcon,
  Mask2Icon,
  MaskIcon,
  MaskTwoCircleIcon,
  Maximize2Icon,
  Maximize3Icon,
  Maximize4Icon,
  MaximizeArrowIcon,
  MaximizeCircleIcon,
  MaximizeIcon,
  MaximizeRoundedIcon,
  Menu2Icon,
  MenuOutlinedCircleIcon,
  MessageFilterIcon,
  MessageReadIcon,
  MicrophoneIcon,
  MicrophoneOffIcon,
  MicrophoneOffSmallIcon,
  MicrophoneSmallIcon,
  MiniMusicSquareIcon,
  MissedCallIcon,
  MobileIcon,
  MonitorIcon,
  MoreOutlined2Icon,
  MoreOutlinedIcon,
  MoveFolder2Icon,
  MoveFolderIcon,
  MovingStarIcon,
  MultipleProfileAddIcon,
  MusicCircleIcon,
  MusicDashboardIcon,
  MusicFilterIcon,
  MusicLibrary2Icon,
  MusicNoteIcon,
  MusicPlayListIcon,
  MusicRoundedIcon,
  MusicSquareAddIcon,
  MusicSquareIcon,
  MusicSquareRemoveIcon,
  MusicSquareSearchIcon,
  MuteIcon,
  NotesIcon,
  NoteSquareIcon,
  NotificationIcon,
  OmegaCircleIcon,
  OmegaSquareIcon,
  PaintBucketIcon,
  PaperClip2Icon,
  PaperClipIcon,
  ParagraphSpacingIcon,
  ParaLongIcon,
  ParaShortIcon,
  PauseCircleIcon,
  PauseOutlinedIcon,
  PenAddIcon,
  PenCloseIcon,
  PenPath2Icon,
  PenPathIcon,
  PenPathSquareIcon,
  PenRemoveIcon,
  PenTool2Icon,
  PenToolIcon,
  PersonalCardIcon,
  PersonalizedIcon,
  PieChartIcon,
  PinIcon,
  PlanIcon,
  PlayAddIcon,
  PlayDashedCircleIcon,
  PlayOutlinedIcon,
  PlayRemoveIcon,
  PreviousIcon,
  ProfileAddIcon,
  QuickReplyIcon,
  QuoteDownCircleIcon,
  QuoteDownIcon,
  QuoteDownSquareIcon,
  QuoteUpCircleIcon,
  QuoteUpIcon,
  QuoteUpSquareIcon,
  RadioIcon,
  RecordCircleIcon,
  RecordIcon,
  RecordStopIcon,
  RecoveryConvertIcon,
  RefreshIcon,
  RepeatMusicIcon,
  RepeatOneIcon,
  RepeatRandomIcon,
  ReplyIcon,
  ReportIcon,
  RestoreIcon,
  RotateLeftIcon,
  RotateRightIcon,
  RowHorizontalIcon,
  RowVerticalIcon,
  RularAndPenIcon,
  RulerIcon,
  SadEmojiIcon,
  SaveIcon,
  ScissorBorderedIcon,
  ScissorIcon,
  ScreenMirroringIcon,
  SearchIcon,
  SentimentHappyEmojiIcon,
  SentimentSadEmojiIcon,
  ServicesIcon,
  Setting3Icon,
  Setting4Icon,
  Setting5Icon,
  SettingIcon,
  SettingOneCircleIcon,
  SettingsIcon,
  Shapes3Icon,
  ShapesIcon,
  SharedIcon,
  ShieldTickIcon,
  SidebarIcon,
  SidebarLeftIcon,
  SidebarRightIcon,
  SignatureIcon,
  SizeIcon,
  SliderHorizontal2Icon,
  SliderHorizontalIcon,
  SliderVertical2Icon,
  SliderVerticalIcon,
  SmallCapsIcon,
  SmileEmojiIcon,
  SmsAccountSuspendedIcon,
  SmsNotificationIcon,
  SmsTrackingIcon,
  SortIcon,
  SquareLayerIcon,
  StagesIcon,
  StarIcon,
  StatusUpIcon,
  StopCircleIcon,
  styled,
  SubtitleIcon,
  System2Icon,
  SystemIcon,
  TabIcon,
  TextAlignCenterIcon,
  TextAlignJustifyCenterIcon,
  TextAlignJustifyLeftIcon,
  TextAlignJustifyRightIcon,
  TextAlignLeftIcon,
  TextAlignRightIcon,
  TextBlockIcon,
  TextIcon,
  TextItalicIcon,
  TextUnderlineIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  TickCircleIcon,
  TimeIcon,
  ToggleOffCircleIcon,
  ToggleOffIcon,
  ToggleOnCircleIcon,
  ToggleOnIcon,
  TranslateIcon,
  TrendDownIcon,
  TrendUpIcon,
  TriggerIcon,
  TrophyIcon,
  UnArchiveIcon,
  UndeliveredIcon,
  UnLockIcon,
  UploadOutlinedIcon,
  UserEditIcon,
  UserIcon,
  UserRemoveIcon,
  UserResendEmailIcon,
  VerySadEmojiIcon,
  VideoAddIcon,
  VideoCircleIcon,
  VideoHexagonIcon,
  VideoHorizontalIcon,
  VideoIcon,
  VideoLibraryIcon,
  VideoOffIcon,
  VideoRemoveIcon,
  VideoSquareIcon,
  VideoTickIcon,
  VideoTimeIcon,
  VideoVerticalIcon,
  VisibilityOffIcon,
  VisibilityOnIcon,
  VoiceCircleIcon,
  VoiceIcon,
  VoiceSquareIcon,
  VolumeCrossIcon,
  VolumeDownIcon,
  VolumeHighIcon,
  VolumeLowIcon,
  VolumeMuteIcon,
  VolumeUpIcon,
  WebIcon,
  WebsiteIcon,
  WideBrushIcon,
  WideBrushOutlinedIcon,
} from "convertupleads-theme";
import IconTitle from "./IconTitle";

export const IconsWrapper = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill,minmax(90px, 1fr))",
  gap: theme.spacing(1),
  paddingLeft: theme.spacing(1),
}));

const OutlinedIcons = () => {
  return (
    <IconsWrapper>
      <IconTitle
        icon={<SettingsIcon color={"error"} />}
        title={"SettingsIcon"}
      />
      <IconTitle icon={<CampaignIcon />} title={"CampaignIcon"} />
      <IconTitle icon={<AudienceIcon />} title={"AudienceIcon"} />
      <IconTitle icon={<WebsiteIcon />} title={"WebsiteIcon"} />
      <IconTitle icon={<DashboardIcon />} title={"DashboardIcon"} />
      <IconTitle icon={<NotificationIcon />} title={"NotificationIcon"} />
      <IconTitle icon={<PlanIcon />} title={"PlanIcon"} />
      <IconTitle icon={<SearchIcon />} title={"SearchIcon"} />
      <IconTitle icon={<CollapseSidebarIcon />} title={"CollapseSidebarIcon"} />
      <IconTitle icon={<ExpandSidebarIcon />} title={"ExpandSidebarIcon"} />
      <IconTitle icon={<ChevronUpDownIcon />} title={"ChevronUpDownIcon"} />
      <IconTitle icon={<InboxIcon />} title={"InboxIcon"} />
      <IconTitle icon={<ReportIcon />} title={"ReportIcon"} />
      <IconTitle icon={<ServicesIcon />} title={"ServicesIcon"} />
      <IconTitle icon={<EmailBuilderIcon />} title={"EmailBuilderIcon"} />
      <IconTitle icon={<TriggerIcon />} title={"TriggerIcon"} />
      <IconTitle icon={<FormBuilderIcon />} title={"FormBuilderIcon"} />
      <IconTitle icon={<AutomationIcon />} title={"AutomationIcon"} />
      <IconTitle icon={<MarketingIcon />} title={"MarketingIcon"} />
      <IconTitle icon={<ArrowRightIcon />} title={"ArrowRightIcon"} />
      <IconTitle icon={<ArrowUpIcon />} title={"ArrowUpIcon"} />
      <IconTitle icon={<ArrowLeftIcon />} title={"ArrowLeftIcon"} />
      <IconTitle icon={<ArrowDownIcon />} title={"ArrowDownIcon"} />
      <IconTitle icon={<ChevronDownIcon />} title={"ChevronDownIcon"} />
      <IconTitle icon={<ChevronUpIcon />} title={"ChevronUpIcon"} />
      <IconTitle icon={<ChevronLeftIcon />} title={"ChevronLeftIcon"} />
      <IconTitle icon={<ChevronRightIcon />} title={"ChevronRightIcon"} />
      <IconTitle icon={<ArrowUpCircleIcon />} title={"ArrowUpCircleIcon"} />
      <IconTitle
        icon={<ArrowRightCircleIcon />}
        title={"ArrowRightCircleIcon"}
      />
      <IconTitle icon={<ArrowLeftCircleIcon />} title={"ArrowLeftCircleIcon"} />
      <IconTitle icon={<ArrowDownCircleIcon />} title={"ArrowDownCircleIcon"} />
      <IconTitle icon={<SidebarRightIcon />} title={"SidebarRightIcon"} />
      <IconTitle icon={<SidebarLeftIcon />} title={"SidebarLeftIcon"} />
      <IconTitle icon={<SidebarIcon />} title={"SidebarIcon"} />
      <IconTitle icon={<ExportIcon />} title={"ExportIcon"} />
      <IconTitle icon={<InfoCircleIcon />} title={"InfoCircleIcon"} />
      <IconTitle icon={<ExportCircleIcon />} title={"ExportCircleIcon"} />
      <IconTitle icon={<RefreshIcon />} title={"RefreshIcon"} />
      <IconTitle icon={<RestoreIcon />} title={"RestoreIcon"} />
      <IconTitle icon={<TickCircleIcon />} title={"TickCircleIcon"} />
      <IconTitle icon={<MonitorIcon />} title={"MonitorIcon"} />
      <IconTitle icon={<TabIcon />} title={"TabIcon"} />
      <IconTitle icon={<MobileIcon />} title={"MobileIcon"} />
      <IconTitle icon={<DragIndicatorIcon />} title={"DragIndicatorIcon"} />
      <IconTitle icon={<MoveFolderIcon />} title={"MoveFolderIcon"} />
      <IconTitle icon={<Folder2Icon />} title={"Folder2Icon"} />
      <IconTitle icon={<AiMailIcon />} title={"AiMailIcon"} />
      <IconTitle icon={<MailIcon />} title={"MailIcon"} />
      <IconTitle icon={<SmsTrackingIcon />} title={"SmsTrackingIcon"} />
      <IconTitle icon={<SmsNotificationIcon />} title={"SmsNotificationIcon"} />
      <IconTitle icon={<MailSettingsIcon />} title={"MailSettingsIcon"} />
      <IconTitle icon={<UndeliveredIcon />} title={"UndeliveredIcon"} />
      <IconTitle icon={<MessageFilterIcon />} title={"MessageFilterIcon"} />
      <IconTitle icon={<MessageReadIcon />} title={"MessageReadIcon"} />
      <IconTitle icon={<ShieldTickIcon />} title={"ShieldTickIcon"} />
      <IconTitle icon={<CallOutgoingIcon />} title={"CallOutgoingIcon"} />
      <IconTitle icon={<AddIcon />} title={"AddIcon"} />
      <IconTitle icon={<CallIcon />} title={"CallIcon"} />
      <IconTitle icon={<CheckIcon />} title={"CheckIcon"} />
      <IconTitle icon={<EditIcon />} title={"EditIcon"} />
      <IconTitle icon={<DeleteIcon />} title={"DeleteIcon"} />
      <IconTitle icon={<ArchiveIcon />} title={"ArchiveIcon"} />
      <IconTitle icon={<UnArchiveIcon />} title={"UnArchiveIcon"} />
      <IconTitle icon={<ManageIcon />} title={"ManageIcon"} />
      <IconTitle icon={<CloseIcon />} title={"CloseIcon"} />
      <IconTitle icon={<ListIcon />} title={"ListIcon"} />
      <IconTitle icon={<ColumnsIcon />} title={"ColumnsIcon"} />
      <IconTitle icon={<SortIcon />} title={"SortIcon"} />
      <IconTitle icon={<FilterIcon />} title={"FilterIcon"} />
      <IconTitle
        icon={<CheckboxUncheckedIcon />}
        title={"CheckboxUncheckedIcon"}
      />
      <IconTitle icon={<PinIcon />} title={"PinIcon"} />
      <IconTitle icon={<VoiceIcon />} title={"VoiceIcon"} />
      <IconTitle icon={<VideoIcon />} title={"VideoIcon"} />
      <IconTitle icon={<LoginIcon />} title={"LoginIcon"} />
      <IconTitle icon={<LogoutIcon />} title={"LogoutIcon"} />
      <IconTitle icon={<DuplicateIcon />} title={"DuplicateIcon"} />
      <IconTitle icon={<NotesIcon />} title={"NotesIcon"} />
      <IconTitle icon={<UserIcon />} title={"UserIcon"} />
      <IconTitle icon={<ActivityIcon />} title={"ActivityIcon"} />
      <IconTitle icon={<TimeIcon />} title={"TimeIcon"} />
      <IconTitle icon={<FlashIcon />} title={"FlashIcon"} />
      <IconTitle icon={<LocationIcon />} title={"LocationIcon"} />
      <IconTitle icon={<CompanyIcon />} title={"CompanyIcon"} />
      <IconTitle icon={<DollarIcon />} title={"DollarIcon"} />
      <IconTitle icon={<WebIcon />} title={"WebIcon"} />
      <IconTitle icon={<BirthdayIcon />} title={"BirthdayIcon"} />
      <IconTitle icon={<FolderIcon />} title={"FolderIcon"} />
      <IconTitle icon={<CollabIcon />} title={"CollabIcon"} />
      <IconTitle icon={<DealsIcon />} title={"DealsIcon"} />
      <IconTitle icon={<FormEntriesIcon />} title={"FormEntriesIcon"} />
      <IconTitle icon={<CallMissedIcon />} title={"CallMissedIcon"} />
      <IconTitle icon={<StarIcon />} title={"StarIcon"} />
      <IconTitle icon={<SaveIcon />} title={"SaveIcon"} />
      <IconTitle icon={<ImageIcon />} title={"ImageIcon"} />
      <IconTitle icon={<AttachmentIcon />} title={"AttachmentIcon"} />
      <IconTitle icon={<BookmarkIcon />} title={"BookmarkIcon"} />
      <IconTitle icon={<CreateIcon />} title={"CreateIcon"} />
      <IconTitle icon={<LinkIcon />} title={"LinkIcon"} />
      <IconTitle icon={<MoveFolder2Icon />} title={"MoveFolder2Icon"} />
      <IconTitle icon={<BlankFolderIcon />} title={"BlankFolderIcon"} />
      <IconTitle icon={<AddFolderIcon />} title={"AddFolderIcon"} />
      <IconTitle icon={<Menu2Icon />} title={"Menu2Icon"} />
      <IconTitle
        icon={<SmsAccountSuspendedIcon />}
        title={"SmsAccountSuspendedIcon"}
      />
      <IconTitle icon={<MissedCallIcon />} title={"MissedCallIcon"} />
      <IconTitle icon={<IncomingCallIcon />} title={"IncomingCallIcon"} />
      <IconTitle icon={<AddCallIcon />} title={"AddCallIcon"} />
      <IconTitle icon={<AnniversaryIcon />} title={"AnniversaryIcon"} />
      <IconTitle icon={<UserRemoveIcon />} title={"UserRemoveIcon"} />
      <IconTitle icon={<UserEditIcon />} title={"UserEditIcon"} />
      <IconTitle icon={<DropIcon />} title={"DropIcon"} />
      <IconTitle icon={<BounceIcon />} title={"BounceIcon"} />
      <IconTitle icon={<ReplyIcon />} title={"ReplyIcon"} />
      <IconTitle icon={<QuickReplyIcon />} title={"QuickReplyIcon"} />
      <IconTitle icon={<CloseBorderedIcon />} title={"CloseBorderedIcon"} />
      <IconTitle icon={<CloseCircleIcon />} title={"CloseCircleIcon"} />
      <IconTitle icon={<ApiCodeIcon />} title={"ApiCodeIcon"} />
      <IconTitle icon={<CodeIcon />} title={"CodeIcon"} />
      <IconTitle icon={<GridIcon />} title={"GridIcon"} />
      <IconTitle icon={<StagesIcon />} title={"StagesIcon"} />
      <IconTitle icon={<AddNewIcon />} title={"AddNewIcon"} />
      <IconTitle icon={<ProfileAddIcon />} title={"ProfileAddIcon"} />
      <IconTitle
        icon={<MultipleProfileAddIcon />}
        title={"MultipleProfileAddIcon"}
      />
      <IconTitle icon={<UserResendEmailIcon />} title={"UserResendEmailIcon"} />
      <IconTitle icon={<ExpandIcon />} title={"ExpandIcon"} />
      <IconTitle icon={<FullScreenIcon />} title={"FullScreenIcon"} />
      <IconTitle icon={<SmileEmojiIcon />} title={"SmileEmojiIcon"} />
      <IconTitle icon={<SadEmojiIcon />} title={"SadEmojiIcon"} />
      <IconTitle icon={<LaughEmojiIcon />} title={"LaughEmojiIcon"} />
      <IconTitle icon={<VerySadEmojiIcon />} title={"VerySadEmojiIcon"} />
      <IconTitle
        icon={<SentimentHappyEmojiIcon />}
        title={"SentimentHappyEmojiIcon"}
      />
      <IconTitle
        icon={<SentimentSadEmojiIcon />}
        title={"SentimentSadEmojiIcon"}
      />
      <IconTitle icon={<TrophyIcon />} title={"TrophyIcon"} />
      <IconTitle icon={<BulbIcon />} title={"BulbIcon"} />
      <IconTitle icon={<CardsIcon />} title={"CardsIcon"} />
      <IconTitle icon={<ThumbsUpIcon />} title={"ThumbsUpIcon"} />
      <IconTitle icon={<ThumbsDownIcon />} title={"ThumbsDownIcon"} />
      <IconTitle icon={<LockIcon />} title={"LockIcon"} />
      <IconTitle icon={<UnLockIcon />} title={"UnLockIcon"} />
      <IconTitle icon={<VideoLibraryIcon />} title={"VideoLibraryIcon"} />
      <IconTitle icon={<UploadOutlinedIcon />} title={"UploadOutlinedIcon"} />
      <IconTitle icon={<RecordIcon />} title={"RecordIcon"} />
      <IconTitle icon={<PersonalizedIcon />} title={"PersonalizedIcon"} />
      <IconTitle icon={<ExtendIcon />} title={"ExtendIcon"} />
      <IconTitle icon={<AIFilledIcon />} title={"AIFilledIcon"} />
      <IconTitle icon={<AIOutlinedIcon />} title={"AIOutlinedIcon"} />
      <IconTitle icon={<MovingStarIcon />} title={"MovingStarIcon"} />
      <IconTitle icon={<ParaLongIcon />} title={"ParaLongIcon"} />
      <IconTitle icon={<ParaShortIcon />} title={"ParaShortIcon"} />
      <IconTitle icon={<BelowIcon />} title={"BelowIcon"} />
      <IconTitle icon={<LoaderIcon />} title={"LoaderIcon"} />
      <IconTitle icon={<HeartOutlinedIcon />} title={"HeartOutlinedIcon"} />
      <IconTitle icon={<MapOutlinedIcon />} title={"MapOutlinedIcon"} />
      <IconTitle icon={<TextAlignLeftIcon />} title={"TextAlignLeftIcon"} />
      <IconTitle icon={<TextAlignCenterIcon />} title={"TextAlignCenterIcon"} />
      <IconTitle icon={<TextAlignRightIcon />} title={"TextAlignRightIcon"} />
      <IconTitle
        icon={<TextAlignJustifyRightIcon />}
        title={"TextAlignJustifyRightIcon"}
      />
      <IconTitle
        icon={<TextAlignJustifyCenterIcon />}
        title={"TextAlignJustifyCenterIcon"}
      />
      <IconTitle
        icon={<TextAlignJustifyLeftIcon />}
        title={"TextAlignJustifyLeftIcon"}
      />
      <IconTitle icon={<PaperClipIcon />} title={"PaperClipIcon"} />
      <IconTitle icon={<PaperClip2Icon />} title={"PaperClip2Icon"} />
      <IconTitle icon={<LinkNewIcon />} title={"LinkNewIcon"} />
      <IconTitle icon={<Link2Icon />} title={"Link2Icon"} />
      <IconTitle icon={<TextBlockIcon />} title={"TextBlockIcon"} />
      <IconTitle icon={<TextItalicIcon />} title={"TextItalicIcon"} />
      <IconTitle icon={<TextIcon />} title={"TextIcon"} />
      <IconTitle icon={<SmallCapsIcon />} title={"SmallCapsIcon"} />
      <IconTitle icon={<BoldIcon />} title={"BoldIcon"} />
      <IconTitle icon={<TextUnderlineIcon />} title={"TextUnderlineIcon"} />
      <IconTitle
        icon={<ParagraphSpacingIcon />}
        title={"ParagraphSpacingIcon"}
      />
      <IconTitle icon={<MaximizeIcon />} title={"MaximizeIcon"} />
      <IconTitle icon={<EraserSquareIcon />} title={"EraserSquareIcon"} />
      <IconTitle icon={<AttachSquareIcon />} title={"AttachSquareIcon"} />
      <IconTitle icon={<AttachSquareIcon />} title={"AttachSquareIcon"} />
      <IconTitle icon={<AttachCircleIcon />} title={"AttachCircleIcon"} />
      <IconTitle icon={<QuoteUpIcon />} title={"QuoteUpIcon"} />
      <IconTitle icon={<QuoteDownIcon />} title={"QuoteDownIcon"} />
      <IconTitle icon={<QuoteUpSquareIcon />} title={"QuoteUpSquareIcon"} />
      <IconTitle icon={<QuoteDownSquareIcon />} title={"QuoteDownSquareIcon"} />
      <IconTitle icon={<QuoteUpCircleIcon />} title={"QuoteUpCircleIcon"} />
      <IconTitle icon={<QuoteDownCircleIcon />} title={"QuoteDownCircleIcon"} />
      <IconTitle icon={<Link4Icon />} title={"Link4Icon"} />
      <IconTitle icon={<LinkSquareIcon />} title={"LinkSquareIcon"} />
      <IconTitle icon={<LinkCircleIcon />} title={"LinkCircleIcon"} />
      <IconTitle icon={<TranslateIcon />} title={"TranslateIcon"} />
      <IconTitle icon={<KanbanIcon />} title={"KanbanIcon"} />
      <IconTitle icon={<FatRowsIcon />} title={"FatRowsIcon"} />
      <IconTitle icon={<RowVerticalIcon />} title={"RowVerticalIcon"} />
      <IconTitle icon={<RowHorizontalIcon />} title={"RowHorizontalIcon"} />
      <IconTitle
        icon={<SliderHorizontalIcon />}
        title={"SliderHorizontalIcon"}
      />
      <IconTitle icon={<SliderVerticalIcon />} title={"SliderVerticalIcon"} />
      <IconTitle icon={<SliderVertical2Icon />} title={"SliderVertical2Icon"} />
      <IconTitle
        icon={<SliderHorizontal2Icon />}
        title={"SliderHorizontal2Icon"}
      />
      <IconTitle icon={<Grid4Icon />} title={"Grid4Icon"} />
      <IconTitle icon={<Grid9Icon />} title={"Grid9Icon"} />
      <IconTitle icon={<Grid2Icon />} title={"Grid2Icon"} />
      <IconTitle icon={<Grid3Icon />} title={"Grid3Icon"} />
      <IconTitle icon={<Grid5Icon />} title={"Grid5Icon"} />
      <IconTitle icon={<Grid6Icon />} title={"Grid6Icon"} />
      <IconTitle icon={<Grid7Icon />} title={"Grid7Icon"} />
      <IconTitle icon={<Grid8Icon />} title={"Grid8Icon"} />
      <IconTitle icon={<Grid1Icon />} title={"Grid1Icon"} />
      <IconTitle icon={<Element1Icon />} title={"Element1Icon"} />
      <IconTitle icon={<Element2Icon />} title={"Element2Icon"} />
      <IconTitle icon={<Element3Icon />} title={"Element3Icon"} />
      <IconTitle icon={<Element4Icon />} title={"Element4Icon"} />
      <IconTitle icon={<ElementPlusIcon />} title={"ElementPlusIcon"} />
      <IconTitle icon={<ElementEqualIcon />} title={"ElementEqualIcon"} />
      <IconTitle icon={<SquareLayerIcon />} title={"SquareLayerIcon"} />
      <IconTitle icon={<AlignVerticallyIcon />} title={"AlignVerticallyIcon"} />
      <IconTitle
        icon={<AlignHorizontallyIcon />}
        title={"AlignHorizontallyIcon"}
      />
      <IconTitle icon={<AlignLeftIcon />} title={"AlignLeftIcon"} />
      <IconTitle icon={<AlignRightIcon />} title={"AlignRightIcon"} />
      <IconTitle icon={<AlignTopIcon />} title={"AlignTopIcon"} />
      <IconTitle icon={<AlignBottomIcon />} title={"AlignBottomIcon"} />
      <IconTitle icon={<MaximizeRoundedIcon />} title={"MaximizeRoundedIcon"} />
      <IconTitle icon={<Maximize2Icon />} title={"Maximize2Icon"} />
      <IconTitle icon={<Maximize3Icon />} title={"Maximize3Icon"} />
      <IconTitle icon={<Maximize4Icon />} title={"Maximize4Icon"} />
      <IconTitle icon={<FormatCircleIcon />} title={"FormatCircleIcon"} />
      <IconTitle icon={<FormatSquareIcon />} title={"FormatSquareIcon"} />
      <IconTitle icon={<RotateLeftIcon />} title={"RotateLeftIcon"} />
      <IconTitle icon={<RotateRightIcon />} title={"RotateRightIcon"} />
      <IconTitle icon={<CropIcon />} title={"CropIcon"} />
      <IconTitle icon={<MaximizeArrowIcon />} title={"MaximizeArrowIcon"} />
      <IconTitle icon={<ConvertShapeIcon />} title={"ConvertShapeIcon"} />
      <IconTitle icon={<ConvertShape2Icon />} title={"ConvertShape2Icon"} />
      <IconTitle icon={<GridLockIcon />} title={"GridLockIcon"} />
      <IconTitle icon={<GridEditIcon />} title={"GridEditIcon"} />
      <IconTitle icon={<GridEraserIcon />} title={"GridEraserIcon"} />
      <IconTitle icon={<Category2Icon />} title={"Category2Icon"} />
      <IconTitle icon={<SettingIcon />} title={"SettingIcon"} />
      <IconTitle icon={<Setting3Icon />} title={"Setting3Icon"} />
      <IconTitle icon={<Setting4Icon />} title={"Setting4Icon"} />
      <IconTitle icon={<Setting5Icon />} title={"Setting5Icon"} />
      <IconTitle icon={<MoreOutlinedIcon />} title={"MoreOutlinedIcon"} />
      <IconTitle icon={<MoreOutlined2Icon />} title={"MoreOutlined2Icon"} />
      <IconTitle icon={<ToggleOffIcon />} title={"ToggleOffIcon"} />
      <IconTitle icon={<ToggleOnIcon />} title={"ToggleOnIcon"} />
      <IconTitle icon={<ToggleOffCircleIcon />} title={"ToggleOffCircleIcon"} />
      <IconTitle icon={<ToggleOnCircleIcon />} title={"ToggleOnCircleIcon"} />
      <IconTitle
        icon={<MenuOutlinedCircleIcon />}
        title={"MenuOutlinedCircleIcon"}
      />
      <IconTitle icon={<CandleIcon />} title={"CandleIcon"} />
      <IconTitle icon={<Candle2Icon />} title={"Candle2Icon"} />
      <IconTitle
        icon={<SettingOneCircleIcon />}
        title={"SettingOneCircleIcon"}
      />
      <IconTitle icon={<ChartSuccessIcon />} title={"ChartSuccessIcon"} />
      <IconTitle icon={<ChartFailIcon />} title={"ChartFailIcon"} />
      <IconTitle icon={<Chart2Icon />} title={"Chart2Icon"} />
      <IconTitle icon={<PieChartIcon />} title={"PieChartIcon"} />
      <IconTitle icon={<ActivityReportIcon />} title={"ActivityReportIcon"} />
      <IconTitle icon={<HomeTrendUpIcon />} title={"HomeTrendUpIcon"} />
      <IconTitle icon={<HomeTrendDownIcon />} title={"HomeTrendDownIcon"} />
      <IconTitle icon={<IncreaseIcon />} title={"IncreaseIcon"} />
      <IconTitle icon={<DecreaseIcon />} title={"DecreaseIcon"} />

      <IconTitle icon={<HomeHashTagIcon />} title={"HomeHashTagIcon"} />
      <IconTitle icon={<TrendUpIcon />} title={"TrendUpIcon"} />
      <IconTitle icon={<TrendDownIcon />} title={"TrendDownIcon"} />
      <IconTitle icon={<GridOutlinedIcon />} title={"GridOutlinedIcon"} />
      <IconTitle icon={<Chart1Icon />} title={"Chart1Icon"} />
      <IconTitle icon={<PersonalCardIcon />} title={"PersonalCardIcon"} />
      <IconTitle icon={<StatusUpIcon />} title={"StatusUpIcon"} />
      <IconTitle icon={<DiagramIcon />} title={"DiagramIcon"} />
      <IconTitle icon={<ChartOutlinedIcon />} title={"ChartOutlinedIcon"} />
      <IconTitle icon={<HealthIcon />} title={"HealthIcon"} />
      <IconTitle
        icon={<BarChartOutlinedIcon />}
        title={"BarChartOutlinedIcon"}
      />
      <IconTitle icon={<FavChartIcon />} title={"FavChartIcon"} />
      <IconTitle icon={<BezierIcon />} title={"BezierIcon"} />
      <IconTitle icon={<BrushIcon />} title={"BrushIcon"} />
      <IconTitle icon={<BrushOutlinedIcon />} title={"BrushOutlinedIcon"} />
      <IconTitle icon={<MagicPenIcon />} title={"MagicPenIcon"} />
      <IconTitle icon={<PenToolIcon />} title={"PenToolIcon"} />
      <IconTitle icon={<ColorGroupIcon />} title={"ColorGroupIcon"} />
      <IconTitle icon={<PaintBucketIcon />} title={"PaintBucketIcon"} />
      <IconTitle icon={<AddItemIcon />} title={"AddItemIcon"} />
      <IconTitle icon={<RulerIcon />} title={"RulerIcon"} />
      <IconTitle icon={<DesignToolsIcon />} title={"DesignToolsIcon"} />
      <IconTitle icon={<ShapesIcon />} title={"ShapesIcon"} />
      <IconTitle icon={<LifebouyIcon />} title={"LifebouyIcon"} />
      <IconTitle icon={<PenTool2Icon />} title={"PenTool2Icon"} />
      <IconTitle icon={<BrushBorderedIcon />} title={"BrushBorderedIcon"} />
      <IconTitle icon={<PenCloseIcon />} title={"PenCloseIcon"} />
      <IconTitle icon={<PenAddIcon />} title={"PenAddIcon"} />
      <IconTitle icon={<PenRemoveIcon />} title={"PenRemoveIcon"} />
      <IconTitle icon={<PenPathIcon />} title={"PenPathIcon"} />
      <IconTitle icon={<PenPath2Icon />} title={"PenPath2Icon"} />
      <IconTitle icon={<BucketCircleIcon />} title={"BucketCircleIcon"} />
      <IconTitle icon={<WideBrushIcon />} title={"WideBrushIcon"} />
      <IconTitle icon={<ScissorIcon />} title={"ScissorIcon"} />
      <IconTitle icon={<GlassBikarIcon />} title={"GlassBikarIcon"} />
      <IconTitle icon={<RularAndPenIcon />} title={"RularAndPenIcon"} />
      <IconTitle icon={<ColorSwatchIcon />} title={"ColorSwatchIcon"} />
      <IconTitle icon={<Blend2Icon />} title={"Blend2Icon"} />
      <IconTitle icon={<PenPathSquareIcon />} title={"PenPathSquareIcon"} />
      <IconTitle icon={<OmegaCircleIcon />} title={"OmegaCircleIcon"} />
      <IconTitle icon={<OmegaSquareIcon />} title={"OmegaSquareIcon"} />
      <IconTitle icon={<Shapes3Icon />} title={"Shapes3Icon"} />
      <IconTitle icon={<SizeIcon />} title={"SizeIcon"} />
      <IconTitle icon={<FlashCircleIcon />} title={"FlashCircleIcon"} />
      <IconTitle icon={<EraserIcon />} title={"EraserIcon"} />
      <IconTitle icon={<MaskIcon />} title={"MaskIcon"} />
      <IconTitle icon={<BlurIcon />} title={"BlurIcon"} />
      <IconTitle icon={<BlendIcon />} title={"BlendIcon"} />
      <IconTitle icon={<ColorFilterIcon />} title={"ColorFilterIcon"} />
      <IconTitle icon={<ColorsSquareIcon />} title={"ColorsSquareIcon"} />
      <IconTitle icon={<Mask2Icon />} title={"Mask2Icon"} />
      <IconTitle
        icon={<WideBrushOutlinedIcon />}
        title={"WideBrushOutlinedIcon"}
      />
      <IconTitle icon={<LayerOutlinedIcon />} title={"LayerOutlinedIcon"} />
      <IconTitle icon={<CopySuccessIcon />} title={"CopySuccessIcon"} />
      <IconTitle icon={<RecoveryConvertIcon />} title={"RecoveryConvertIcon"} />
      <IconTitle icon={<MainComponentIcon />} title={"MainComponentIcon"} />
      <IconTitle icon={<ComponentIcon />} title={"ComponentIcon"} />
      <IconTitle icon={<MaskTwoCircleIcon />} title={"MaskTwoCircleIcon"} />
      <IconTitle icon={<ForwardItemIcon />} title={"ForwardItemIcon"} />
      <IconTitle icon={<BackwardItemIcon />} title={"BackwardItemIcon"} />
      <IconTitle icon={<MicrophoneIcon />} title={"MicrophoneIcon"} />
      <IconTitle icon={<MicrophoneOffIcon />} title={"MicrophoneOffIcon"} />
      <IconTitle icon={<MicrophoneSmallIcon />} title={"MicrophoneSmallIcon"} />
      <IconTitle
        icon={<MicrophoneOffSmallIcon />}
        title={"MicrophoneOffSmallIcon"}
      />
      <IconTitle icon={<VolumeCrossIcon />} title={"VolumeCrossIcon"} />
      <IconTitle icon={<MuteIcon />} title={"MuteIcon"} />
      <IconTitle icon={<VolumeUpIcon />} title={"VolumeUpIcon"} />
      <IconTitle icon={<VolumeDownIcon />} title={"VolumeDownIcon"} />
      <IconTitle icon={<VolumeLowIcon />} title={"VolumeLowIcon"} />
      <IconTitle icon={<VolumeHighIcon />} title={"VolumeHighIcon"} />
      <IconTitle icon={<VolumeMuteIcon />} title={"VolumeMuteIcon"} />
      <IconTitle icon={<VideoOffIcon />} title={"VideoOffIcon"} />
      <IconTitle icon={<VideoSquareIcon />} title={"VideoSquareIcon"} />
      <IconTitle icon={<VideoCircleIcon />} title={"VideoCircleIcon"} />
      <IconTitle icon={<ImageFavIcon />} title={"ImageFavIcon"} />
      <IconTitle icon={<ImageOffIcon />} title={"ImageOffIcon"} />
      <IconTitle icon={<ImageTickIcon />} title={"ImageTickIcon"} />
      <IconTitle icon={<ImageImportIcon />} title={"ImageImportIcon"} />
      <IconTitle icon={<ImageExportIcon />} title={"ImageExportIcon"} />
      <IconTitle icon={<ImageAddIcon />} title={"ImageAddIcon"} />
      <IconTitle icon={<ImageRemoveIcon />} title={"ImageRemoveIcon"} />
      <IconTitle icon={<ImageEditIcon />} title={"ImageEditIcon"} />
      <IconTitle icon={<ImageNoBorderIcon />} title={"ImageNoBorderIcon"} />
      <IconTitle icon={<ScreenMirroringIcon />} title={"ScreenMirroringIcon"} />
      <IconTitle icon={<CameraIcon />} title={"CameraIcon"} />
      <IconTitle icon={<CameraOffIcon />} title={"CameraOffIcon"} />
      <IconTitle icon={<PlayOutlinedIcon />} title={"PlayOutlinedIcon"} />
      <IconTitle icon={<RecordCircleIcon />} title={"RecordCircleIcon"} />
      <IconTitle icon={<RecordStopIcon />} title={"RecordStopIcon"} />
      <IconTitle icon={<MusicNoteIcon />} title={"MusicNoteIcon"} />
      <IconTitle icon={<MusicRoundedIcon />} title={"MusicRoundedIcon"} />
      <IconTitle icon={<VideoVerticalIcon />} title={"VideoVerticalIcon"} />
      <IconTitle icon={<VideoHorizontalIcon />} title={"VideoHorizontalIcon"} />
      <IconTitle icon={<SubtitleIcon />} title={"SubtitleIcon"} />
      <IconTitle icon={<StopCircleIcon />} title={"StopCircleIcon"} />
      <IconTitle icon={<PauseCircleIcon />} title={"PauseCircleIcon"} />
      <IconTitle icon={<PauseOutlinedIcon />} title={"PauseOutlinedIcon"} />
      <IconTitle icon={<ScissorBorderedIcon />} title={"ScissorBorderedIcon"} />
      <IconTitle icon={<BackwardIcon />} title={"BackwardIcon"} />
      <IconTitle icon={<ForwardIcon />} title={"ForwardIcon"} />
      <IconTitle icon={<PreviousIcon />} title={"PreviousIcon"} />
      <IconTitle icon={<RadioIcon />} title={"RadioIcon"} />
      <IconTitle icon={<MusicCircleIcon />} title={"MusicCircleIcon"} />
      <IconTitle
        icon={<PlayDashedCircleIcon />}
        title={"PlayDashedCircleIcon"}
      />
      <IconTitle icon={<PlayRemoveIcon />} title={"PlayRemoveIcon"} />
      <IconTitle icon={<PlayAddIcon />} title={"PlayAddIcon"} />
      <IconTitle icon={<Backward5SecIcon />} title={"Backward5SecIcon"} />
      <IconTitle icon={<Backward10SecIcon />} title={"Backward10SecIcon"} />
      <IconTitle icon={<Backward15SecIcon />} title={"Backward15SecIcon"} />
      <IconTitle icon={<Forward5SecIcon />} title={"Forward5SecIcon"} />
      <IconTitle icon={<Forward10SecIcon />} title={"Forward10SecIcon"} />
      <IconTitle icon={<Forward15SecIcon />} title={"Forward15SecIcon"} />
      <IconTitle icon={<MusicPlayListIcon />} title={"MusicPlayListIcon"} />
      <IconTitle icon={<MusicFilterIcon />} title={"MusicFilterIcon"} />
      <IconTitle icon={<MusicDashboardIcon />} title={"MusicDashboardIcon"} />
      <IconTitle
        icon={<MusicSquareRemoveIcon />}
        title={"MusicSquareRemoveIcon"}
      />
      <IconTitle icon={<MusicSquareAddIcon />} title={"MusicSquareAddIcon"} />
      <IconTitle
        icon={<MusicSquareSearchIcon />}
        title={"MusicSquareSearchIcon"}
      />
      <IconTitle icon={<RepeatMusicIcon />} title={"RepeatMusicIcon"} />
      <IconTitle icon={<RepeatOneIcon />} title={"RepeatOneIcon"} />
      <IconTitle icon={<RepeatRandomIcon />} title={"RepeatRandomIcon"} />
      <IconTitle
        icon={<DevicesControllerIcon />}
        title={"DevicesControllerIcon"}
      />
      <IconTitle icon={<MusicLibrary2Icon />} title={"MusicLibrary2Icon"} />
      <IconTitle icon={<MusicSquareIcon />} title={"MusicSquareIcon"} />
      <IconTitle icon={<AudioSquareIcon />} title={"AudioSquareIcon"} />
      <IconTitle icon={<NoteSquareIcon />} title={"NoteSquareIcon"} />
      <IconTitle icon={<MiniMusicSquareIcon />} title={"MiniMusicSquareIcon"} />
      <IconTitle icon={<VideoAddIcon />} title={"VideoAddIcon"} />
      <IconTitle icon={<VideoRemoveIcon />} title={"VideoRemoveIcon"} />
      <IconTitle icon={<VideoTickIcon />} title={"VideoTickIcon"} />
      <IconTitle icon={<VideoTimeIcon />} title={"VideoTimeIcon"} />
      <IconTitle icon={<VideoHexagonIcon />} title={"VideoHexagonIcon"} />
      <IconTitle icon={<VoiceSquareIcon />} title={"VoiceSquareIcon"} />
      <IconTitle icon={<VoiceCircleIcon />} title={"VoiceCircleIcon"} />
      <IconTitle icon={<MaximizeCircleIcon />} title={"MaximizeCircleIcon"} />
      <IconTitle icon={<ChurnReportsIcon />} title={"ChurnReportsIcon"} />
      <IconTitle icon={<DividerIcon />} title={"DividerIcon"} />
      <IconTitle icon={<LogoIcon />} title={"LogoIcon"} />
      <IconTitle icon={<SignatureIcon />} title={"SignatureIcon"} />
      <IconTitle icon={<SystemIcon />} title={"SytemIcon"} />
      <IconTitle icon={<EmailIcon />} title={"EmailIcon"} />
      <IconTitle icon={<System2Icon />} title={"System2Icon"} />
      <IconTitle icon={<Email2Icon />} title={"Email2Icon"} />
      <IconTitle icon={<LayoutIcon />} title={"LayoutIcon"} />
      <IconTitle icon={<FirstLineIcon />} title={"FirstLineIcon"} />
      <IconTitle icon={<ColorPaletteIcon />} title={"ColorPaletteIcon"} />
      <IconTitle icon={<ClockIcon />} title={"ClockIcon"} />
      <IconTitle icon={<CalenderIcon />} title={"CalenderIcon"} />
      <IconTitle icon={<VisibilityOffIcon />} title={"VisibilityOffIcon"} />
      <IconTitle icon={<VisibilityOnIcon />} title={"VisibilityOnIcon"} />
      <IconTitle icon={<HelpIcon />} title={"HelpIcon"} />
      <IconTitle icon={<SharedIcon />} title={"SharedIcon"} />
      <IconTitle icon={<DownloadIcon />} title={"DownloadIcon"} />
      <IconTitle icon={<Edit1Icon />} title={"Edit1Icon"} />
    </IconsWrapper>
  );
};

export default OutlinedIcons;
